import React from 'react';

import { TradingEventsListRow } from './TradingEventsListRow';
import { TABS } from './config';

import CreateEventModal from '../../CreateEventModal';

import { SmallModelRowType, TradingEventsListState } from './TradingEventsList.state';
import { TradingEventsListHeader } from './TradingEventsListHeader';
import { observer } from 'src/utils/mobx-react';
import { TradingEventsListTopHeader } from './TradingEventsListTopHeader';
import { TradingEventsListLoading } from './TradingEventsListLoading';

const renderElements = (tradingEventsListState: TradingEventsListState, list: Array<SmallModelRowType>): React.ReactElement => {
    const tab = tradingEventsListState.tab;

    const elements = list.map(event => {
        return (
            <TradingEventsListRow
                key={ event.id }
                columns={ TABS[tab] }
                eventId={ event.id }
                eventName={ event.name }
                startTime= { event.startTime }
            />
        );
    });

    return (
        <tbody>
            { elements }
        </tbody>
    );
};

const renderShowMoreButton = (tradingEventsListState: TradingEventsListState): React.ReactNode => {
    if (tradingEventsListState.isLoading) {
        return null;
    }

    if (tradingEventsListState.isShowMore) {
        return (
            <button className='trading-events-list__show-more' onClick={tradingEventsListState.showMore}>
                SHOW MORE
            </button>
        );
    }

    return null;
};

interface PropsType {
    tradingEventsListState: TradingEventsListState,
}

export const TradingEventsList = observer('TradingEventsList', (props: PropsType) => {
    const { tradingEventsListState } = props;
    const { createEvent, events } = tradingEventsListState;

    return (
        <div className='trading-events-list'>
            <TradingEventsListTopHeader tradingEventsListState={tradingEventsListState} />
            <table className='trading-events-list-table table__striped'>
                <TradingEventsListHeader tradingEventsListState={tradingEventsListState} />
                { renderElements(tradingEventsListState, events) }
            </table>
            { renderShowMoreButton(tradingEventsListState) }
            <CreateEventModal
                active={ createEvent }
                onClose={ tradingEventsListState.hideCreateEvent }
                onFinish={ tradingEventsListState.onAddEventFinish }
            />
            <TradingEventsListLoading
                tradingEventsListState={tradingEventsListState}
            />
        </div>
    );
});
